import React from 'react';
import { signOut, useSession } from 'next-auth/react';
import { useLazyQuery } from '@apollo/client';
import { User } from '../models';
import { SMALL_CURRENT_USER } from '../graphql/queries';

interface IUserContext {
  user: User;
  setUser: React.Dispatch<React.SetStateAction<User>>;
}

export const UserContext = React.createContext<IUserContext>({
  user: null,
  setUser: () => {},
});

interface UserContextProviderProps {
  children: React.ReactNode;
}

export function UserContextProvider({ children }: UserContextProviderProps) {
  const session = useSession();
  const [user, setUser] = React.useState<User>(null);
  const [currentUser, { data, loading }] = useLazyQuery<{
    currentUser: {
      user: User;
    };
  }>(SMALL_CURRENT_USER);

  const value = React.useMemo(() => ({ user, setUser }), [user]);

  React.useEffect(() => {
    if (session.status === 'authenticated') {
      // set local storage token
      localStorage.setItem('x-token', session.data.user.accessToken);

      const { expires } = session.data;
      // varify session expiration

      if (expires && new Date(expires).getTime() - new Date().getTime() < 0) {
        // sign out
        signOut();
      }

      // const expires = data.currentUser.user.;
      console.log('session', session);
    } else if (session.status === 'unauthenticated') {
      setUser(null);
    }
  }, [session?.data?.user, session?.status]);

  React.useEffect(() => {
    if (!loading && data) {
      setUser(data.currentUser?.user);
    }
  }, [data]);

  React.useEffect(() => {
    if (session.status === 'authenticated') {
      currentUser({
        variables: {
          id: session.data.user._id,
        },
      });
    }
  }, [loading]);

  return (
    <UserContext.Provider value={value}>
      {loading ? null : children}
    </UserContext.Provider>
  );
}
